<template>
  <div class="member-manage">
    <div style="display: flex; justify-content: flex-end">
      <Button type="primary" @click="getCode">获取小程序二维码</Button>
    </div>
    <Tabs v-model="activeTab">
      <TabPane label="机构" name="name1">
        <companyList></companyList>
      </TabPane>
      <TabPane label="个人" name="name2">
        <person-list></person-list>
      </TabPane>
      <TabPane label="职位" name="name3">
        <position-list></position-list>
      </TabPane>
    </Tabs>

    <Modal v-model="showCode" title="会员二维码" footer-hide>
      <div class="model-content" style="text-align: center; margin: 30px auto">
        <img :src="qrcode" style="margin: 0 auto; width: 150px; height: 150px" alt="" />
        <div class="tips" style="margin-top: 10px">使用微信扫码</div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import personList from './person/list.vue'
  import companyList from './company/list.vue'
  import positionList from './position/list.vue'
  import * as apiProgramCode from '@/api/activity/index'
  export default {
    components: {
      personList,
      companyList,
      positionList,
    },
    data() {
      return {
        activeTab: 'name1',
        showCode: false,
        qrcode: '',
      }
    },
    created() {
      this.syncTabFromRoute()
    },
    watch: {
      $route() {
        this.syncTabFromRoute()
      },
    },
    methods: {
      /** 从路由 query.tab 同步当前 Tab */
      syncTabFromRoute() {
        this.activeTab = this.$route.query.tab || 'name1'
      },
      /** 获取小程序二维码 */
      getCode() {
        this.$store.commit('setSpinShow', true)
        apiProgramCode
          .apiGetProgramCode({
            type: 3,
          })
          .then(res => {
            const { url } = res.data
            this.qrcode = url
            this.showCode = true
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },
    },
  }
</script>
